import { createFileRoute } from "@tanstack/react-router";
import { SavedDashboardsPage } from "@/components/paid-media/dashboards/dashboards-page";

export const Route = createFileRoute("/dashboard/paid-media/_layout/dashboards")({
  component: SavedDashboardsPage,
});
